import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {Product} from 'src/app/shared/classes/product';

import {ModalService} from 'src/app/shared/services/modal.service';
import {CartService} from 'src/app/shared/services/cart.service';
import {WishlistService} from 'src/app/shared/services/wishlist.service';

import {environment} from 'src/environments/environment';
import {Lightbox} from 'ngx-lightbox';
import {AuthenticationService} from '../../../services/authentication.service';
import {User} from '../../../classes/app.models';

@Component({
    selector: 'indiapicture-product-ten',
    templateUrl: './product-ten.component.html',
    styleUrls: ['./product-ten.component.scss']
})

export class ProductTenComponent implements OnInit {

    @Input() product: Product;
    @Input() previewArr = [];
    @Input() index = 0;
    @Input() type: string;
    @Input('listingType') listingType = '';

    maxPrice = 0;
    minPrice = 99999;

    SERVER_URL = environment.SERVER_URL;
    private currentUser: User;

    constructor(
        private router: Router,
        private modalService: ModalService,
        private cartService: CartService,
        private wishlistService: WishlistService,
        private _lightbox: Lightbox,
        private authenticationService: AuthenticationService
    ) {
        this.authenticationService.currentUser?.subscribe(x => this.currentUser = x);
    }

    ngOnInit(): void {
        let min = this.minPrice;
        let max = this.maxPrice;
    }

    addToCart(event: Event) {
        event.preventDefault();
        this.cartService.addToCart(this.product);
    }

    addToWishlist(event: Event) {
        event.preventDefault();
        if (this.currentUser) {
            this.modalService.showWishListView(this.product);
        } else {
            this.modalService.showLoginModal();
        }

    }

    // addToCompare(event: Event) {
    //     event.preventDefault();
    //     if (this.isInCompare()) {
    //         return;
    //     }
    //     this.compareService.addToCompare(this.product);
    // }

    // quickView(event: Event) {
    //     event.preventDefault();
    //     this.modalService.showQuickView(this.product);
    // }

    // isInCompare() {
    //     return this.compareService.isInCompare(this.product);
    // }

    isInWishlist() {
        return this.wishlistService.isInWishlist(this.product);
    }

    open(index: number, $event): void {
        $event.preventDefault();
        if (this.type == 'images') {
            if (this.previewArr.length == 1) {
                this._lightbox.open(this.previewArr, 0);

            } else {
                this._lightbox.open(this.previewArr, index);
            }
        } else {
            this.modalService.showVideoModal(this.product.preview);
        }
    }



    close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }


}
